export const Style = {
  Header: {
    HeaderWrapper: {
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      zIndex: 2,
      p: 2,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: 'common.white',
      borderBottom: '1px solid',
      borderColor: 'common.borderColor',
    },
    HeaderLogo: {},
    NotificationNumber: {
      bgcolor: '#EF4444',
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    UserProfile: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      borderRadius: 1,
      border: '0.8px solid',
      borderColor: 'common.borderColor',
    },
    UserForm: {
      minWidth: 120,
      '.MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    ProfileButton: {
      color: 'text.primary',
      textTransform: 'capitalize',
      p: 1.5,
      minWidth: 150,
      justifyContent: 'space-between',
    },
  },
  CompanySetting: {
    CompanySettingWrapper: {
      minHeight: '100vh',
      bgcolor: 'common.pageBackground',
    },
    PageHeadTitle: {
      px: { xs: 3, md: 4 },
      py: { xs: 3, md: 4, lg: 6 },
      bgcolor: 'common.white',
    },
    MenuList: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      px: { xs: 3, md: 4 },
      py: { xs: 1, md: 3 },
      bgcolor: '#FBFBFF',
    },
    MenuListItem: {
      color: 'grey.600',
      fontWeight: '600',
      p: 1,
      fontSize: '14px',
      textDecoration: 'none',
      '&:hover': {
        color: 'primary.main',
        textDecoration: 'underline',
      },
      '&.active': {
        color: 'primary.main',
        textDecoration: 'underline',
      },
    },
  },
  UserNameRound: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    width: 32,
    height: 32,
    m: '10px 7px',
    bgcolor: 'common.grey',
    borderRadius: '50%',
  },
  UserNameRoundBig: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    width: 44,
    height: 44,
    m: 1,
    bgcolor: 'common.grey',
    borderRadius: '50%',
    fontSize: '16px',
  },
};
